<div class="list-page laskut list-loading">
  <app-asiakas-otsikko otsikko="Selaa laskuja, Lemonaidissa näkyvät laskut" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <div class="ylaosan-kontrollit">
    <div class="hakukontrollit">
      <mat-form-field floatPlaceholder="never">
        <mat-label>{{ 'laskut.nayta' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.tila">
          @for (tila of laskunTilatObservable | async; track tila) {
            <mat-option [value]="tila.tunnus">
              {{ tila.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field floatPlaceholder="never">
        <mat-label>{{ 'laskut.rajaa-kuukausia' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.kuukausi">
          @for (kuukausi of kuukausivaihtoehdotObservable | async; track kuukausi.tunnus) {
            <mat-option [value]="kuukausi.tunnus">
              {{ kuukausi.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-button additionalClass="etsi-nappi" matIcon="search" ariaHaspopup="dialog" [ariaLabel]="'laskut.haku.avaa-haku' | translate | async" (click)="avaaHaku()" actionId="Laskulista: avaa haku">
        {{ 'laskut.etsi' | translate | async }}
      </app-button>
    </div>
  </div>

  @if (avoinnaTo() || avoinnaTo() === 0) {
    <div class="summatContainer">
      <div class="summat">
        <div>
          <div class="otsikko">{{ 'laskut.summat.avoinna' | translate | async }}</div>
          <div class="maara blue-text" appCountTo [step]="16.667" [countTo]="avoinnaTo()" [countFrom]="avoinnaFrom()" [duration]="1" (countToChange)="countToAvoinna = $event" (countToEnd)="onCountToEnd()">{{ countToAvoinna | lmoney: valuutta() | async }}</div>
        </div>
        <div>
          <div class="otsikko">{{ 'laskut.summat.eraantynyt' | translate | async }}</div>
          <div class="maara red-text" [class.red-text]="eraantynytTo() !== 0" [class.green-text]="eraantynytTo() === 0" appCountTo [step]="16.667" [countTo]="eraantynytTo()" [countFrom]="eraantynytFrom()" [duration]="1" (countToChange)="countToEraantynyt = $event" (countToEnd)="onCountToEnd()">
            {{ countToEraantynyt | lmoney: valuutta() | async }}
          </div>
        </div>
      </div>
    </div>
  }

  <div style="max-width: 1200px; overflow-x: auto; margin: 0 5px; text-align: center">
    <div style="position: relative; min-height: 200px; display: inline-block; text-align: left">
      <table class="laskut-table" style="border-spacing: 0; margin: 0 auto">
        @if ({ showCommentsColumn: (tableViewOptionsObservable | async)?.showCommentsColumn }; as tbvOpts) {
          <thead>
            <tr class="mat-mdc-header-row">
              <th class="mat-mdc-header-cell mat-column-tila">{{ 'laskut.tila' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-nro">{{ 'laskut.numero' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-asiakas">{{ 'laskut.asiakas' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-pvm">{{ 'laskut.laskun-pvm' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-erapvm">{{ 'laskut.erapaiva' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-summa align-header-right">{{ 'laskut.summa' | translate | async }}</th>
              <th class="mat-mdc-header-cell mat-column-avoinna align-header-right">{{ 'laskut.avoinna' | translate | async }}</th>
              @if (tbvOpts.showCommentsColumn) {
                <th class="mat-mdc-header-cell mat-column-merkitse">{{ 'laskut.merkitse-maksetuksi' | translate | async }}</th>
              }
              @if (tbvOpts.showCommentsColumn) {
                <th class="mat-mdc-header-cell mat-column-kommentti">{{ 'laskut.kommentti' | translate | async }}</th>
              }
            </tr>
          </thead>
        }
        @if ({ showCommentsColumn: (tableViewOptionsObservable | async)?.showCommentsColumn }; as tbvOpts) {
          <tbody>
            @for (row of nakyvatRivitObservable | async; track row) {
              <tr (click)="muokkaa(row)" class="mat-mdc-row" [class.lemon-lapsi]="row.tyyppi === 'l'" [class.lemon-lapsi-viimeinen]="row.tyyppi === 'lv'" [class.lemon-vanhempi]="row.tyyppi === 'v'">
                <td class="mat-mdc-cell mat-column-tila" [class.blue-text]="row.vari === 'blue'" [class.yellow-text]="row.vari === 'yellow'" [class.green-text]="row.vari === 'green'" [class.red-text]="row.vari === 'red'" [class.purple-text]="row.vari === 'purple'" [class.mint-text]="row.vari === 'mint'">
                  @if (row.lahetysEpaonnistui) {
                    <table style="border-spacing: 0">
                      <tr>
                        <td [matTooltip]="'laskut.lahettaminen-epaonnistui' | translate | async" style="color: red; font-size: 32px; font-weight: bold; vertical-align: middle; padding-right: 4px; border-bottom: none">!</td>
                        <td style="vertical-align: top; border-bottom: none">
                          @if (row.tyyppi === 't' || row.tyyppi === 'v') {
                            <span class="tila-pilleri">{{ row.tilanKaannosavain | translate | async }}</span>
                          }
                        </td>
                      </tr>
                    </table>
                  } @else {
                    @if (row.tyyppi === 't' || row.tyyppi === 'v') {
                      <span class="tila-pilleri">{{ row.tilanKaannosavain | translate | async }}</span>
                    }
                  }
                </td>
                <td class="mat-mdc-cell mat-column-nro">{{ row.nro }}</td>
                <td class="mat-mdc-cell mat-column-asiakas">{{ row.asiakas }}</td>
                <td class="mat-mdc-cell mat-column-pvm">{{ row.pvm | lokaalipvm | async }}</td>
                <td class="mat-mdc-cell mat-column-erapvm">
                  @if (row.juurilasku?.kateislasku && (row.tyyppi === 't' || row.tyyppi === 'v')) {
                    <span class="gray-text">{{ 'laskut.kateislasku' | translate | async }}</span>
                  } @else {
                    {{ row.erapvm | lokaalipvm | async }}
                  }
                  @if (row.paiviaMyohassa !== null) {
                    <div class="pv-myohassa red-text">{{ 'laskut.pv-myohassa' | translate: { paivia: row.paiviaMyohassa } | async }}</div>
                  }
                </td>
                <td class="mat-mdc-cell mat-column-summa">
                  @if (row.summaEuroina !== undefined) {
                    {{ row.summaEuroina | lmoney: 'EUR' | async }}
                    <div class="alkuperainen-summa gray-text">{{ row.summa | lmoney: row.valuutta | async }}</div>
                  } @else {
                    {{ row.summa | lmoney: row.valuutta | async }}
                  }
                </td>
                <td class="mat-mdc-cell mat-column-avoinna">
                  @if ((row.tyyppi === 'v' || row.tyyppi === 't') && row.tila !== 'lu' && row.nrotyyppi !== 'h') {
                    @if (row.avoinnaEuroina !== undefined) {
                      {{ row.avoinnaEuroina | lmoney: 'EUR' | async }}
                      <div class="alkuperainen-summa gray-text">{{ row.avoinna | lmoney: row.valuutta | async }}</div>
                    } @else {
                      {{ row.avoinna | lmoney: row.valuutta | async }}
                    }
                  }
                </td>
                @if (tbvOpts.showCommentsColumn) {
                  <td class="mat-mdc-cell mat-column-merkitse">
                    @if ((row.tyyppi === 't' || row.tyyppi === 'v') && row.tila !== 'l' && row.tila !== 'lu' && row.tila !== 'mi' && row.tila !== 'h') {
                      <app-button
                        [dynamicClass]="{
                          'blue-text': row.vari === 'blue',
                          'yellow-text': row.vari === 'yellow',
                          'green-text': row.vari === 'green',
                          'red-text': row.vari === 'red',
                          'purple-text': row.vari === 'purple',
                          'mint-text': row.vari === 'mint',
                          'mat-elevation-z4': row.avoinna > 0,
                        }"
                        additionalClass="maksetuksi-button"
                        (click)="merkitseMaksetuksi(row); $event.stopPropagation()"
                        actionId="Merkitse maksetuksi/Peru maksumerkintä"
                      >
                        <mat-icon>done</mat-icon>
                      </app-button>
                    }
                  </td>
                }
                @if (tbvOpts.showCommentsColumn) {
                  <td class="mat-mdc-cell mat-column-kommentti">
                    @if (row?.juurilasku?.kommentti; as kommentti) {
                      <pre (click)="modifyComment(row.juurilasku); $event.stopPropagation()">{{ kommentti }}</pre>
                    }
                    @if (!row?.juurilasku?.kommentti) {
                      <app-button additionalClass="kommentti-button mat-elevation-z4" (click)="modifyComment(row.juurilasku); $event.stopPropagation()" actionId="Avasi dialogin: lisää kommentti"> + </app-button>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        }
        @if ({ showCommentsColumn: (tableViewOptionsObservable | async)?.showCommentsColumn }; as tbvOpts) {
          <tfoot>
            @for (rivi of yhteensaRivitObservable | async; track rivi) {
              <tr class="mat-mdc-footer-row dark-gray-text">
                <td class="mat-mdc-footer-cell mat-column-tila" style="border-bottom-color: transparent">&nbsp;</td>
                <td class="mat-mdc-footer-cell mat-column-nro" style="border-bottom-color: transparent"></td>
                <td class="mat-mdc-footer-cell mat-column-asiakas" style="border-bottom-color: transparent; text-align: right; padding-right: 10px" colspan="3">Näkyvät rivit yhteensä:</td>
                <td class="mat-mdc-footer-cell mat-column-summa" style="border-bottom-color: transparent">{{ rivi.laskutettu | lmoney: rivi.valuutta | async }}</td>
                <td class="mat-mdc-footer-cell mat-column-avoinna" style="border-bottom-color: transparent">{{ rivi.avoinna | lmoney: rivi.valuutta | async }}</td>
                <td class="mat-mdc-footer-cell mat-column-merkitse" style="border-bottom-color: transparent"></td>
                @if (tbvOpts.showCommentsColumn) {
                  <td class="mat-mdc-footer-cell mat-column-kommentti"></td>
                }
              </tr>
            }
          </tfoot>
        }
      </table>
      @if (lataaObservable | async) {
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-items: center; align-items: center">
          <div lemon-loading [config]="loadingSettings" [show]="true"></div>
        </div>
      }
      @if (naytaEiYhtaanObservable | async) {
        <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div style="width: 100%; padding-top: 40px; text-align: center">
            {{ 'laskut.hakuehdoilla-ei-yhtaan-tulosta' | translate | async }}
          </div>
        </div>
      }
    </div>
  </div>
  <div style="min-height: 200px; max-width: 1200px; overflow-x: auto; margin: 0 5px">
    <mat-paginator #paginator [length]="dataSource?.rivienMaaraObservable | async" [pageSize]="dataSource?.page?.pageSize" [pageIndex]="dataSource?.page?.pageIndex" [pageSizeOptions]="[20, 50, 200, 500, 1000, 5000]"> </mat-paginator>
  </div>

  <h3 class="light-blue-text">Ulkoisissa järjestelmissä luodut laskut, jotka eivät näy Lemonaidissa</h3>
  <div app-piilotetut-laskut></div>
</div>
<app-lasku-haku-lemonator [avoinna]="hakuAvoinna()" (suljettu)="suljeHaku()"></app-lasku-haku-lemonator>
